import { Result } from 'entities/result'
import { ReactNode } from 'react'
import { ResultInfoV2, ResultV2ViewModel, RiskData, RiskScore } from './result_v2_view_model'
import { Symptom } from 'components/send_history/result_v2'
import { Sample } from 'entities/sample'

export type PancreasRiskScore = RiskScore & {
    blood_type: number
    pancreas_family_history: number
    disease: number
    smoking: number
    alcohol: number
    BMI: number
}
type PancreasRiskRatio = PancreasRiskScore

type PancreasResultInfoV2 = ResultInfoV2 & {
    risk_score: PancreasRiskScore
    risk_ratio: PancreasRiskRatio
    risk_data: RiskData<PancreasRiskScore>
}

export class PancreasResultV2ViewModel extends ResultV2ViewModel {
    constructor(result: Result, sample: Sample) {
        super(result, 'すい臓がん', '0.1%程度', '1%程度', sample)
    }
    public info(): PancreasResultInfoV2 {
        return super.info() as PancreasResultInfoV2
    }

    public blood_type = () => {
        if (this.background.bloodType !== 'unknown') {
            return `${this.background.bloodType}型`
        } else {
            return '不明'
        }
    }

    public pancreas_family_history = () => {
        const familyHistory = this.background.familyHistories?.find((fh) => fh.cancer === 'pancreas' && fh.withinFirstDegreeRelative != 0)
        if (familyHistory) {
            return `${familyHistory.withinFirstDegreeRelative}人`
        } else {
            return '該当なし'
        }
    }

    public disease = () => {
        let hasDisease = false
        this.background?.medicalHistories?.forEach((mh) => {
            if (!hasDisease) {
                hasDisease = ['diabetes', 'chronic_pancreatitis', 'pancreatic_cyst', 'gastric_ulcer', 'periodontal_disease'].includes(mh.disease!)
            }
        })
        if (hasDisease) {
            return '該当する'
        } else {
            return '該当なし'
        }
    }

    public smoking = () => {
        if (this.background.smoking === 'now') {
            return '吸う'
        } else if (this.background.smoking === 'ever') {
            return 'やめた'
        } else {
            return '吸わない'
        }
    }

    public alcohol = () => {
        if (this.background.alcoholPerWeek === 0) {
            return '飲まない'
        } else if (this.background.alcoholPerWeek === 0.5) {
            return '月に数日'
        } else {
            return `週に${this.background.alcoholPerWeek}日`
        }
    }

    public symptomsView(symptoms: Symptom[]): ReactNode {
        return super.symptomsView(symptoms, 15)
    }

    public getMiddleTextPosition(): { bottom: number; left: number } {
        return { bottom: 135, left: 142 }
    }
    public getHighTextPosition(): { top: number; right: number } {
        return { top: 2, right: 5 }
    }
}
